"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Accordion_component_exports = {};
__export(Accordion_component_exports, {
  Accordion: () => Accordion
});
module.exports = __toCommonJS(Accordion_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_AngleDown = __toESM(require("@greatmindsorg/gmui-icons-lib/dist/AngleDown"));
var import_Button = require("../Button/Button.component");
var import_Checkbox = require("../Checkbox/Checkbox.component");
const Accordion = ({
  children,
  isOpen,
  link,
  onClick,
  title,
  variant = "secondary",
  parentType,
  description,
  label,
  semanticLabel,
  customHideLabel = "Hide",
  customShowLabel = "Show",
  usage = "accordion",
  checkboxProps,
  id = (0, import_react.useId)()
}) => {
  const [internalOpenState, setInternalOpenState] = (0, import_react.useState)(isOpen);
  const useInternalState = typeof onClick !== "function";
  const handleClick = (0, import_react.useCallback)(() => {
    if (useInternalState) {
      setInternalOpenState(!internalOpenState);
    } else {
      onClick();
    }
  }, [internalOpenState, onClick, useInternalState]);
  const showContent = useInternalState ? internalOpenState : isOpen;
  const buttonSemantic = semanticLabel || (parentType === "courses" ? "h2" : parentType === "modules" ? "h3" : parentType === "lessons" ? "h4" : "span");
  let buttonText = showContent ? customHideLabel : customShowLabel;
  let accordionTitle = title || buttonText;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "div",
      {
        className: variant !== "tertiary" ? `w-full ${usage === "accordionWithCheckbox" ? description ? "relative" : "gmui-accordion-height relative" : ""}` : "",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            import_Button.Button,
            {
              "aria-expanded": showContent,
              onPress: handleClick,
              "data-testid": "item-container",
              variant,
              usage: variant !== "tertiary" ? usage : "",
              className: `${variant !== "tertiary" ? `gmui-accordion-button-default gmui-border-width-1-shadow gmui-justify-left w-full ${usage === "accordionWithCheckbox" ? "gmui-accordion-checkbox-button" : ""}` : ""} ${showContent && variant !== "tertiary" ? usage === "accordionWithCheckbox" ? "gmui-accordion-checkbox-expanded-border-top" : "gmui-accordion-expanded-border-top" : ""}`,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  import_Button.Button.Icon,
                  {
                    position: "left",
                    className: `transition-transform duration-300 ease-out ${showContent ? "-rotate-180" : "rotate-0"}`,
                    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_AngleDown.default, { iconSize: "m", title: "arrow", ariaHidden: true })
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { semanticLabel: buttonSemantic, children: accordionTitle }),
                description && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  "div",
                  {
                    id: `accordion-description-id-${id}`,
                    "data-testid": "accordion-button-description",
                    className: `gmui-font-style-body mx-0 mb-0 justify-self-start py-0 pr-0 text-left text-[--color-content-hierarchy-prim] ${usage === "accordionWithCheckbox" ? "gmui-accordion-checkbox-description mt-0 pl-[2.625rem] pr-4" : "mt-xs pl-m"}`,
                    children: description
                  }
                ),
                label && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                  "div",
                  {
                    id: `accordion-label-id-${id}`,
                    "data-testid": "accordion-button-label",
                    className: "gmui-font-style-body-compact gmui-themed-font-weight-body-medium mx-0 mb-0 mt-xs justify-self-start py-0 pl-m pr-0 text-left text-[--color-content-hierarchy-sec]",
                    children: label
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { children: link })
              ]
            }
          ),
          usage === "accordionWithCheckbox" && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "span",
            {
              className: `absolute left-[25px] ${description ? "gmui-accordion-checkbox-description-position-top" : "gmui-accordion-checkbox-position-top"}`,
              children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
                import_Checkbox.Checkbox,
                __spreadProps(__spreadValues({}, checkboxProps), {
                  ariaLabel: "Select all checkbox for list within the accordion"
                })
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "div",
      {
        className: `origin-top transition-all duration-300 ease-out ${showContent ? "h-auto opacity-100" : "h-0 scale-y-[0.1] opacity-0"}`,
        children: variant !== "tertiary" ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
          "div",
          {
            "data-testid": "accordion-default-content-wrapper",
            className: "gmui-accordion-expanded-border-bottom justify-left items-left mt-0 flex flex-col gap-0 bg-inset p-m",
            children: showContent ? children : null
          }
        ) : children
      }
    )
  ] });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Accordion
});
//# sourceMappingURL=Accordion.component.js.map